import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "skeleton__container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"skeleton__form-section\"><div class=\"skeleton__item col-12\"></div><div class=\"skeleton__form-section__row\"><div class=\"skeleton__item col-4\"></div><div class=\"skeleton__item col-4\"></div><div class=\"skeleton__item col-4\"></div></div></div><div class=\"skeleton__form-section\"><div class=\"skeleton__item col-12\"></div><div class=\"skeleton__item col-12\"></div><div class=\"skeleton__form-section__row\"><div class=\"skeleton__item col-6\"></div><div class=\"skeleton__item col-6\"></div></div></div>", 2)

import SkeletonAnimation from './SkeletonAnimation.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(SkeletonAnimation)
  ]))
}
}

})